import { Exception } from '@microsoft/applicationinsights-web';
import axios from 'axios';
import { resolve } from 'dns';
//import { appInsights } from '../AppInsights';
import { v4 as uuid } from 'uuid';

  export const getConfig:any = () => {
      var data:any=sessionStorage.getItem('Config');
      var config = JSON.parse(data);
    if(!config)
    {
        return new Promise((resolve:any)=>{
            axios.get('environment-config.json')
                .then(res => {
                  sessionStorage.setItem('Config',JSON.stringify(res.data));
                  sessionStorage.setItem('correlationId',uuid());
                   resolve(res.data);
                }) 
                .catch(error => {   
                    //appInsights.trackException({exception:error,severityLevel:1});                
                })
        })
    
    }
    else{
     
        return  Promise.resolve(config);
    }
}


